import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'formatNumber'
})
export class FormatNumberPipe implements PipeTransform {
    transform(number: any, format: any): any {
        if (number === undefined) {
            return undefined
        }

        if (typeof number === 'string') {
            number = Number.parseInt(number, 10)
        }

        if (Number.isNaN(number)) {
            throw new Error('A input de entrada não é um número válido.')
        }

        return formatNumber(number, format)
    }
}

export function formatNumber(number: number, format: string) {
    let output
    const reverse = format.indexOf('?') === -1
    let valuePosition = 0
    let inputValues = number.toString().split('')

    const formatChars = format.split('')

    if (reverse) {
        inputValues = inputValues.reverse()

        output = formatChars
            .reverse()
            .map(char => {
                switch (char) {
                    case '0':
                    case '9':
                        return inputValues[valuePosition++] || '0'
                    case '?':
                        return ''
                    default:
                        return char
                }
            })
            .reverse()
    } else {
        output = formatChars.map(char => {
            switch (char) {
                case '0':
                case '9':
                    return inputValues[valuePosition++] || ''
                case '?':
                    return ''
                default:
                    return char
            }
        })
    }

    return output.join('')
}



// WEBPACK FOOTER //
// ./src/app/common/format-number.pipe.ts